import { Reducer as routerReducer } from 'modules/router';
import { Reducer as _routerReducer } from '../router';
import { Reducer as loginReducer } from 'modules/login';
import { Reducer as languageReducer } from 'modules/language-provider';
import { Reducer as IPLocationReducer } from 'modules/IP-location';
import { Reducer as eventReducer } from 'modules/event-manager';
import { Reducer as platformSelection } from '../modules/platform-selection';
import { Reducer as loadingManagerReducer } from 'modules/loading-manager';
import { Reducer as focusReducer } from 'modules/focus-observer';
import IConfig from '@sitegen/common/constants/config';

const reducers = {
    [routerReducer.reducerKey]: _routerReducer.default,
    [IPLocationReducer.reducerKey]: IPLocationReducer.default,
    [eventReducer.reducerKey]: eventReducer.default,
    [loginReducer.reducerKey]: loginReducer.default,
    [languageReducer.reducerKey]: languageReducer.default,
    [platformSelection.reducerKey]: platformSelection.default,
    [loadingManagerReducer.reducerKey]: loadingManagerReducer.default,
    [focusReducer.reducerKey]: focusReducer.default
};

export type State = {
    readonly router: ReturnType<typeof _routerReducer.default>,
    readonly IPLocation: ReturnType<typeof IPLocationReducer.default>,
    readonly event: ReturnType<typeof eventReducer.default>,
    readonly login: ReturnType<typeof loginReducer.default>,
    readonly language: ReturnType<typeof languageReducer.default>,
    readonly platform: ReturnType<typeof platformSelection.default>,
    readonly loadingManager: ReturnType<typeof loadingManagerReducer.default>,
    readonly hasFocus: boolean,
    readonly config: IConfig
};

export default reducers;
